import dayjs from "dayjs";

import noticeAccount from "@/components/modal/noticeAccount/layout.vue";

export default {
  metaInfo: {
    title: "아이디/비밀번호 찾기",
  },
  components: { noticeAccount },
  data() {
    return {
      findType: "id",
      user: {
        phoneNumber: "",
        authCode: "",
        userId: "",
      },
      isVerifiedUser: false,
      sendAuthCodeMsg: "인증번호 발송",
      reSendAuthCodeMsg: "인증번호 재발송",
      isSendIdAuthCode: false,
      isSendPwAuthCode: false,
      defaultDate: null,
      idTimeOver: false,
      pwTimeOver: false,
      idIntervalTimer: null,
      pwIntervalTimer: null,
      idTimerDate: "1999-01-01 00:05:00",
      pwTimerDate: "1999-01-01 00:05:00",
      openModal: false,
      popup: "",
      phoneReReg: /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/,
      isCorrect: "",
      isValidId: true,
    };
  },
  mounted() {},
  created() {
    this.stopTimer();
  },
  destroyed() {
    this.stopTimer();
  },
  computed: {
    isPhoneInsert() {
      if (/^(010)([0-9]{4})([0-9]{4})$/.test(this.user.phoneNumber)) {
        return true;
      } else if (
        /^01([1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/.test(this.user.phoneNumber)
      ) {
        return true;
      }
      return false;
    },
    isAuthCodeInsert() {
      if (this.user.authCode) return true;
      return false;
    },
    isAvailableFindId() {
      if (this.isVerifiedUser && !this.idTimeOver) return true;

      return false;
    },
    isAvailableFindPw() {
      if (this.isVerifiedUser && !this.pwTimeOver) return true;

      return false;
    },
    idTimer: {
      get() {
        return dayjs(this.idTimerDate).format("mm:ss");
      },
      set(value) {},
    },
    pwTimer: {
      get() {
        return dayjs(this.pwTimerDate).format("mm:ss");
      },
      set(value) {},
    },
    test() {
      if (!this.isPhoneInsert || this.user.userId.length === 0) return true;
      return false;
    },
  },
  methods: {
    //인증번호 확인하기
    verifyAuthCode() {
      if (!this.availableToSendVerifyCode()) return;
      const payload = {
        phoneNumber: this.user.phoneNumber,
        code: this.user.authCode,
      };
      try {
        this.$store.dispatch("account/verifyAuthCode", payload).then((data) => {
          if (data.success) {
            this.isVerifiedUser = true;
            this.isCorrect = "success";
            this.stopTimer();
          } else {
            this.isCorrect = "fail";
            this.isVerifiedUser = false;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    availableToSendVerifyCode() {
      if (this.findType === "id") {
        if (!this.isSendIdAuthCode) {
          this.isAvailableFindId = false;
          return false;
        }

        if (!this.isAuthCodeInsert) {
          this.isCorrect = "fail";
          return false;
        }

        if (this.idTimeOver) {
          return false;
        }
        return true;
      } else {
        if (!this.isSendPwAuthCode) {
          this.isAvailableFindPw = false;
          return false;
        }

        if (!this.isAuthCodeInsert) {
          this.isCorrect = "fail";
          return false;
        }

        if (this.pwTimeOver) {
          return false;
        }
        return true;
      }
    },
    setSendAuthCode(state) {
      if (this.findType === "id") this.isSendIdAuthCode = state;
      else this.isSendPwAuthCode = state;
    },
    setTimeOver(state) {
      if (this.findType === "id") this.idTimeOver = state;
      else this.pwTimeOver = state;
    },
    //인증번호 발송
    sendAuthCode() {
      this.isValidId = true;
      this.stopTimer();
      let authCodeReqURL = "";
      let payload;

      if (this.findType === "id") {
        payload = {
          phoneNumber: this.user.phoneNumber,
        };
        authCodeReqURL = "requestIdAuthCode";
        this.idTimerDate = "1999-01-01 00:05:00";
      } else {
        authCodeReqURL = "requestPwAuthCode";
        this.pwTimerDate = "1999-01-01 00:05:00";

        payload = {
          userId: this.user.userId,
          phoneNumber: this.user.phoneNumber,
        };
      }

      try {
        this.$store
          .dispatch(`account/${authCodeReqURL}`, payload)
          .then((data) => {
            if (data.success) {
              this.openNoticeModal(
                "인증번호를 발송했어요! \n가입되지 않은 사용자의 경우,\n인증번호 수신이 어려울 수 있어요.😥"
              );
              this.user.authCode = "";
              this.startTimer();
              this.setSendAuthCode(true);

              this.setTimeOver(false);
            } else {
              if (data.code === 4040) {
                this.isValidId = false;
              }
            }
          });
      } catch (error) {
        console.error(error);
      }
    },

    moveToFindId() {
      this.$store.dispatch("account/initializationUserInfo");
      this.$router.replace("/users/find-id");
      this.stopTimer();
    },
    checkValidId() {
      return this.isValidId;
    },

    FindId() {
      try {
        this.$store.dispatch("account/findUserIdList").then((data) => {
          this.moveToFindId();
        });
      } catch (error) {
        console.error(error);
      }
    },
    startTimer() {
      if (this.findType === "id") this.startIdTimer();
      else this.startPwTimer();
    },
    startIdTimer() {
      this.idIntervalTimer = setInterval(() => {
        this.idTimerDate = dayjs(this.idTimerDate).subtract(1, "second");

        if (dayjs(this.idTimerDate).format("mm:ss") === "00:00") {
          this.stopIdTimer();
          this.idTimeOver = true;
        }
      }, 1000);
    },
    startPwTimer() {
      this.pwIntervalTimer = setInterval(() => {
        this.pwTimerDate = dayjs(this.pwTimerDate).subtract(1, "second");

        if (dayjs(this.pwTimerDate).format("mm:ss") === "00:00") {
          this.stopPwTimer();
          this.pwTimeOver = true;
        }
      }, 1000);
    },
    stopTimer() {
      if (this.findType === "id") this.stopIdTimer();
      else this.stopPwTimer();
    },
    stopIdTimer() {
      clearInterval(this.idIntervalTimer);
    },
    stopPwTimer() {
      clearInterval(this.pwIntervalTimer);
    },
    setDefaultUserInfo() {
      this.stopTimer();
      this.user = {
        phoneNumber: "",
        authCode: "",
        userId: "",
      };
      this.isVerifiedUser = false;
      this.setSendAuthCode(false);
      this.setTimeOver(false);
      this.setDefaultTimer();
    },
    setDefaultTimer() {
      if (this.findType === "id") this.idTimerDate = "1999-01-01 00:05:00";
      else this.pwTimerDate = "1999-01-01 00:05:00";
    },
    //비밀번호 찾기
    findPw() {
      this.$router.replace("/users/update-pw");
      this.stopTimer();
    },
    openNoticeModal(popup) {
      this.openModal = true;
      this.popup = popup;
    },

    trimOnBlur() {
      this.user.userId = this.user.userId.replace(/\s/g, "");
    },
  },
};
